import { render, staticRenderFns } from "./CadastroExercicio.vue?vue&type=template&id=56d147a2&scoped=true&"
import script from "./CadastroExercicio.vue?vue&type=script&lang=js&"
export * from "./CadastroExercicio.vue?vue&type=script&lang=js&"
import style0 from "./CadastroExercicio.vue?vue&type=style&index=0&id=56d147a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d147a2",
  null
  
)

export default component.exports